import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import styles from './UploadButton.scss';

import newId from '../../../_util/newId';

class UploadButton extends Component {
  componentWillMount() {
      this.id = newId();
  }
  render () {
  	let classNames = styles.a_button;
    if(this.props.theme=='dark'){
      classNames = classNames + ' ' + styles.isDark
    }

    if(this.props.theme=='light'){
      classNames = classNames + ' ' + styles.isLight
    }

    if(this.props.nomargin){
      classNames = classNames + ' ' + styles.noMargin
    }

    if(this.props.multiline){
      classNames = classNames + ' ' + styles.isMultiline
    }

    return (
      <div className={styles.uploadWrapper}>
        <div className={styles.centerer}>
          <label htmlFor={this.id}>{this.props.label}</label>
        </div>
        <input id={this.id} type="file" className={classNames} style={{ width: this.props.width ? this.props.width : '100%' }} onChange={(event) => this.props.changed(event, this.props.identifier)} accept={this.props.accept}/>
      </div>
    )
  }
}

UploadButton.propTypes = {
  label: PropTypes.node.isRequired,
  identifier: PropTypes.node.isRequired
}

export default UploadButton



// WEBPACK FOOTER //
// ./src/components/atoms/UploadButton/index.js